import React from 'react';
import SideBarLayout from '../../layouts/SidebarLayout';
var sidebarMenu = [
    { name: 'API Setting', icon: 'settings' },
    { name: 'Datasource Config', icon: 'text_snippet' },
    { name: 'Exchange Rate', icon: 'local_atm' },
];
var Administration = function () {
    return (React.createElement(SideBarLayout, { sidebarMenu: sidebarMenu }, "Operator Administrations"));
};
export default Administration;
